export const MINIMUM_ACCURACY_TO_PASS = 20
export const ASR_STATES = { 
    INITIAL: 'initial', 
    INTRODUCTION_SCREEN_1: 'introduction_screen_1', 
    ACTIVITY_STARTED: 'activity_started',
    MAX_ATTEMPTS_HELP: 'max_attempts_help'
}
export const ASR_STATES_PROGRESS = [
  ASR_STATES.INITIAL, 
  ASR_STATES.INTRODUCTION_SCREEN_1, 
  ASR_STATES.ACTIVITY_STARTED
]
export const ASR_EVENTS = {
    STUDENT_PROMPT_SPEECH: 'STUDENT_PROMPT_SPEECH',
    STUDENT_STARTED_SPEAKING: 'STUDENT_STARTED_SPEAKING',
    STUDENT_NOT_TRYING: 'STUDENT_NOT_TRYING', // When ASR did not detect any words
    STUDENT_TIMED_OUT: 'STUDENT_TIMED_OUT',
    STUDENT_FAILED_WITH_BG_NOISE: 'STUDENT_FAILED_WITH_BG_NOISE', // When student's ASR activity scored below the error rate and has background noise.
    STUDENT_FAILED_WITHOUT_BG_NOISE: 'STUDENT_FAILED_WITHOUT_BG_NOISE',
    STUDENT_RETRY_PROMPTED: 'STUDENT_RETRY_PROMPTED',
    STUDENT_RETRY: 'STUDENT_RETRY',
    CALLED_TEACHER: 'CALLED_TEACHER',
    TEACHER_TROUBLESHOOT_CLICKED: 'TEACHER_TROUBLESHOOT_CLICKED',
    TEACHER_TEST_STARTED: 'TEACHER_TEST_STARTED',
    TEACHER_TEST_PROMPT_SPEECH: 'TEACHER_TEST_PROMPT_SPEECH',
    TEACHER_STARTED_SPEAKING: 'TEACHER_STARTED_SPEAKING',
    TEACHER_TEST_NO_SPEECH_DETECTED: 'TEACHER_TEST_NO_SPEECH_DETECTED',
    TEACHER_TIMED_OUT: 'TEACHER_TIMED_OUT',
    TEACHER_TEST_FAILED_WITH_BG_NOISE: 'TEACHER_TEST_FAILED_WITH_BG_NOISE',
    TEACHER_TEST_FAILED_WITHOUT_BG_NOISE: 'TEACHER_TEST_FAILED_WITHOUT_BG_NOISE',
    TEACHER_TEST_FAILED: 'TEACHER_TEST_FAILED',
    TEACHER_TEST_SUCCESS: 'TEACHER_TEST_SUCCESS',
    TEACHER_TEST_BG_NOISE_DETECTED: 'TEACHER_TEST_BG_NOISE_DETECTED',
    TEACHER_RETRY: 'TEACHER_RETRY',
    FLAG_HARD_TO_UNDERSTAND: "FLAG_HARD_TO_UNDERSTAND",
    SKIP_FLAG_HARD_TO_UNDERSTAND: "SKIP_FLAG_HARD_TO_UNDERSTAND",
}